import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=22cc2b95&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc2b95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cc2b95')) {
      api.createRecord('22cc2b95', component.options)
    } else {
      api.reload('22cc2b95', component.options)
    }
    module.hot.accept("./TableList.vue?vue&type=template&id=22cc2b95&scoped=true", function () {
      api.rerender('22cc2b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/traddingWitness/openBidWitness/components/TableList.vue"
export default component.exports